module.exports = __webpack_public_path__ + "static/img/color.27ecbe2e.jpg";